import styled from "styled-components";

export const SocialWrap = styled.div`
    margin-bottom: ${props => props.mb};
    margin-top: ${props => props.mt};
`;